module.exports = __webpack_public_path__ + "img/dhfesta_logo4.cf0e4670.png";